// Case List Page Translation
export default {
  // Page Title
  pageTitle: "Case Analysis - Case List",
  switchToOldVersion: "Switch to Old Version",
  switchToNewVersion: "Switch to New Version",

  // Top Buttons
  allCases: "All Cases",
  myCases: "My Cases",
  createCase: "Create Case",

  // Search Form
  searchForm: {
    caseNamePlaceholder: "Enter case name",
    creatorNamePlaceholder: "Enter creator name",
    startDate: "Start Date",
    endDate: "End Date",
    rangeSeparator: "→",
  },

  // Statistics
  totalData: "Total",
  dataUnit: "records",

  // Table Columns
  tableColumns: {
    index: "No.",
    caseName: "Case Name",
    caseDescription: "Description",
    caseType: "Case Type",
    creator: "Creator",
    createTime: "Created At",
    updateTime: "Updated At",
    operation: "Actions",
  },

  // Action Buttons
  actions: {
    edit: "Edit",
    analyze: "Analyze",
    delete: "Delete",
  },

  // Confirm Dialog
  confirmDialog: {
    deleteTitle: "Confirm",
    deleteMessage:
      "This will permanently delete the case '{caseName}'. Continue?",
    confirmButton: "Confirm",
    cancelButton: "Cancel",
  },

  // Messages
  messages: {
    deleteSuccess: "Successfully deleted!",
    deleteCancelled: "Deletion cancelled",
    noPermission: "You don't have permission to access this page",
  },

  // Loading State
  loading: "Loading...",

  // Empty State
  emptyText: "No data available",
};
